import { render } from "./StorePurchaseRequisition.vue?vue&type=template&id=7c15280d&scoped=true"
import script from "./StorePurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./StorePurchaseRequisition.vue?vue&type=script&lang=js"

import "./StorePurchaseRequisition.vue?vue&type=style&index=0&id=7c15280d&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c15280d"]])

export default __exports__